import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeSection: "dashboard",
  batches: [],
  batchesLoading: false,
  batchesError: null,
  batchStatusFilter: "all",
  activeBatch: null,
  activeBatchLoading: false,
  activeRecordIndex: 0,
  activeRecord: null,
  employeeMatches: [],
  employeeMatchesLoading: false,
  uploadWizard: {
    step: 0,
    files: [],
    metadata: {
      schoolDistrictId: "",
      notes: "",
      sourceTicketId: null,
    },
    uploadProgress: 0,
    processingStatus: "idle",
    batchId: null,
  },
  auditEntries: [],
  auditLoading: false,
  stats: {
    total: 0,
    pending: 0,
    processing: 0,
    inReview: 0,
    needsAttention: 0,
    approved: 0,
    posted: 0,
    rejected: 0,
    error: 0,
  },
};

export const trainingCreditIntakeSlice = createSlice({
  name: "trainingCreditIntake",
  initialState,
  reducers: {
    setActiveSection(state, action) {
      state.activeSection = action.payload;
    },
    setBatchStatusFilter(state, action) {
      state.batchStatusFilter = action.payload;
    },
    setBatches(state, action) {
      state.batches = action.payload;
    },
    setBatchesLoading(state, action) {
      state.batchesLoading = action.payload;
    },
    setBatchesError(state, action) {
      state.batchesError = action.payload;
    },
    setActiveBatch(state, action) {
      state.activeBatch = action.payload;
    },
    setActiveBatchLoading(state, action) {
      state.activeBatchLoading = action.payload;
    },
    setActiveRecordIndex(state, action) {
      state.activeRecordIndex = action.payload;
    },
    setActiveRecord(state, action) {
      state.activeRecord = action.payload;
    },
    setEmployeeMatches(state, action) {
      state.employeeMatches = action.payload;
    },
    setEmployeeMatchesLoading(state, action) {
      state.employeeMatchesLoading = action.payload;
    },
    setUploadWizardStep(state, action) {
      state.uploadWizard.step = action.payload;
    },
    setUploadFiles(state, action) {
      state.uploadWizard.files = action.payload;
    },
    setUploadMetadata(state, action) {
      state.uploadWizard.metadata = { ...state.uploadWizard.metadata, ...action.payload };
    },
    setUploadProgress(state, action) {
      state.uploadWizard.uploadProgress = action.payload;
    },
    setProcessingStatus(state, action) {
      state.uploadWizard.processingStatus = action.payload;
    },
    setUploadBatchId(state, action) {
      state.uploadWizard.batchId = action.payload;
    },
    updateRecordField(state, action) {
      const { recordId, field, value } = action.payload;
      if (state.activeBatch?.records) {
        const rec = state.activeBatch.records.find((r) => r.RecordId === recordId || r.apiid === recordId);
        if (rec) rec[field] = value;
      }
      if (state.activeRecord && (state.activeRecord.RecordId === recordId || state.activeRecord.apiid === recordId)) {
        state.activeRecord[field] = value;
      }
    },
    setRecordStatus(state, action) {
      const { recordId, status } = action.payload;
      if (state.activeBatch?.records) {
        const rec = state.activeBatch.records.find((r) => r.RecordId === recordId || r.apiid === recordId);
        if (rec) rec.Status = status;
      }
      if (state.activeRecord && (state.activeRecord.RecordId === recordId || state.activeRecord.apiid === recordId)) {
        state.activeRecord.Status = status;
      }
    },
    assignEmployee(state, action) {
      const { recordId, userId, userName, matchScore } = action.payload;
      const update = (rec) => {
        rec.MatchedUserId = userId;
        rec.MatchedUserName = userName;
        rec.MatchScore = matchScore;
      };
      if (state.activeBatch?.records) {
        const rec = state.activeBatch.records.find((r) => r.RecordId === recordId || r.apiid === recordId);
        if (rec) update(rec);
      }
      if (state.activeRecord && (state.activeRecord.RecordId === recordId || state.activeRecord.apiid === recordId)) {
        update(state.activeRecord);
      }
    },
    setAuditEntries(state, action) {
      state.auditEntries = action.payload;
    },
    setAuditLoading(state, action) {
      state.auditLoading = action.payload;
    },
    setStats(state, action) {
      state.stats = { ...state.stats, ...action.payload };
    },
    resetUploadWizard(state) {
      state.uploadWizard = initialState.uploadWizard;
    },
    resetTrainingCreditIntake: () => initialState,
  },
});

export const {
  setActiveSection,
  setBatchStatusFilter,
  setBatches,
  setBatchesLoading,
  setBatchesError,
  setActiveBatch,
  setActiveBatchLoading,
  setActiveRecordIndex,
  setActiveRecord,
  setEmployeeMatches,
  setEmployeeMatchesLoading,
  setUploadWizardStep,
  setUploadFiles,
  setUploadMetadata,
  setUploadProgress,
  setProcessingStatus,
  setUploadBatchId,
  updateRecordField,
  setRecordStatus,
  assignEmployee,
  setAuditEntries,
  setAuditLoading,
  setStats,
  resetUploadWizard,
  resetTrainingCreditIntake,
} = trainingCreditIntakeSlice.actions;

export default trainingCreditIntakeSlice.reducer;
